import { gonvarri } from "./chapaQuantity";

export const pt = {
  gonvarri
};
